import { c as _c } from "react/compiler-runtime";
import type { OnboardingDataEntry } from '@onefootprint/request-types/dashboard';
import { categorizeDataValue, formatInlineValue, formatTextValue } from '../utils/data-artifact-utils';
import ExpandableText from './expandable-text';
type DataArtifactsViewProps = {
  artifact: OnboardingDataEntry;
};
const DataArtifactsView = t0 => {
  const $ = _c(13);
  const {
    artifact
  } = t0;
  let t1;
  if ($[0] !== artifact.value) {
    t1 = categorizeDataValue(artifact.value) === "text" ? formatTextValue(artifact.value) : null;
    $[0] = artifact.value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== artifact || $[3] !== t1) {
    t2 = {
      ...artifact,
      formattedTextValue: t1
    };
    $[2] = artifact;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const formattedArtifact = t2;
  const category = categorizeDataValue(artifact.value);
  if (category === "empty") {
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="p-4"><span className="text-label-2 text-tertiary">-</span></div>;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  if (category === "inline") {
    let t3;
    if ($[6] !== artifact.value) {
      t3 = formatInlineValue(artifact.value);
      $[6] = artifact.value;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[8] !== t3) {
      t4 = <div className="p-4"><span className="text-label-2 text-primary">{t3}</span></div>;
      $[8] = t3;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  let t3;
  if ($[10] !== artifact.key || $[11] !== formattedArtifact.formattedTextValue) {
    t3 = <div className="h-full"><ExpandableText value={formattedArtifact.formattedTextValue} filename={artifact.key} /></div>;
    $[10] = artifact.key;
    $[11] = formattedArtifact.formattedTextValue;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export default DataArtifactsView;